import React from 'react';
import {View, StyleSheet} from 'react-native';
import {AppDataMediaItem} from "@/data/app-data-interfaces";
import {useCurrentTheme} from "@/theming/useCurrentTheme";
import {ThemeType} from "@/theming/baseTheme";
import {VideoNavigationControlItem} from "@/components/media/video-detail/VideoNavigationControlItem";

interface VideoNavigationControlsProps {
    previousVideo?: AppDataMediaItem | null;
    nextVideo?: AppDataMediaItem | null;
    onPreviousVideo?: () => void;
    onNextVideo?: () => void;
}

export const VideoNavigationControls: React.FC<VideoNavigationControlsProps> = ({
                                                                                    previousVideo,
                                                                                    nextVideo,
                                                                                    onPreviousVideo,
                                                                                    onNextVideo
                                                                                }) => {
    const {theme} = useCurrentTheme();
    const styles = createStyles(theme);

    // Don't render if neither previous nor next video exists
    if (!previousVideo && !nextVideo) {
        return null;
    }

    return (
        <View style={styles.navigationContainer}>
            {previousVideo && onPreviousVideo && <VideoNavigationControlItem video={previousVideo} direction={'previous'} onPress={onPreviousVideo} />}
            {!previousVideo && <View style={styles.navPlaceholder} />}
            {nextVideo && onNextVideo && <VideoNavigationControlItem video={nextVideo} direction={'next'} onPress={onNextVideo} />}
            {!nextVideo && <View style={styles.navPlaceholder} />}
        </View>
    );
};

const createStyles = (theme: ThemeType) => StyleSheet.create({
    navigationContainer: {
        flexDirection: 'row',
        marginBottom: 20,
        gap: 12,
    },
    navPlaceholder: {
        flex: 1,
        // Takes up the same space as navButton but remains invisible
    },
});
